<template>
	<div ref="tablePage" style="height: 100%">
		<!-- 面包屑导航 -->
		<div class="topNav">
			<div class="navFormWrapper">
				<el-breadcrumb separator-class="el-icon-arrow-right">
					<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
					<el-breadcrumb-item>车位类型管理</el-breadcrumb-item>
				</el-breadcrumb>
				<el-form ref="queryForm" :model="searchForm" inline label-width="68px" style="margin-left: 6vh">
					<el-form-item style="margin-bottom: 0">
						<el-input v-model="searchForm.carport_type" autocomplete="off" maxlength="30" placeholder="车位类型名"
							clearable @input="searchChange" size="small" />
					</el-form-item>
					<el-form-item style="margin-bottom: 0">
						<el-button icon="el-icon-refresh-left" type="warning" @click="clearSearchInput"
							size="small">重置</el-button>
					</el-form-item>
				</el-form>
				<el-button type="success" icon="el-icon-plus" @click="handleNewAdd" size="mini">新增类型</el-button>
			</div>
		</div>
		<el-table :data="tableList" style="width: 100%; margin-top: 2vh" border size="mini"
			:header-cell-style="{background: '#fff',height: '50px',color: '#909399',fontSize: '16px',fontFamily: 'Arial, sans-serif'}">
			<el-table-column prop="carport_type_status" label="类型ID" align="center" />
			<el-table-column prop="carport_type" label="车位类型" align="center" />
			<el-table-column prop="color" label="类型颜色" align="center" >
				<template slot-scope="scope">
					<el-color-picker :value="scope.row.color" @change=""></el-color-picker>
				</template>
			</el-table-column>
			<el-table-column prop="product_type" label="产品ID" align="center" />
			<el-table-column prop="product_name" label="产品名" align="center" />
			<el-table-column prop="width" label="车位宽" align="center" />
			<el-table-column prop="height" label="车位高" align="center" />
			<el-table-column fixed="right" label="操作" align="center">
				<template slot-scope="scope">
					<el-button @click.native.prevent="handleClick(scope.row)" type="primary" size="small"
						icon="el-icon-edit">
						修改
					</el-button>
				</template>
			</el-table-column>
		</el-table>
		<pagination v-show="total > 0" :total="total" :page.sync="searchForm.page" :limit.sync="searchForm.pageSize"
			@pagination="initList" />
		<el-dialog :title="title" :visible.sync="addOrEditOpen" :close-on-click-modal="false" width="45%"
			class="dialogHeight2 global-dialog-position" :before-close="getout" :lock-scroll="false"
			:append-to-body="true" style="margin-top: -10vh">
			<el-form ref="form" :model="form" label-width="108px" :rules="rules">
				<el-row>
					<el-col :span="24">
						<el-form-item label="车位类型" prop="carport_type">
							<el-input v-model="form.carport_type" autocomplete="off" placeholder="请输入车位类型" />
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="选择颜色" prop="color">
							<el-color-picker v-model="form.color"></el-color-picker><el-input v-model="form.color" disabled />
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="产品名" prop="product_name">
							<el-input v-model="form.product_name" autocomplete="off" placeholder="请输入产品名" />
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="车位宽" prop="width">
							<el-input v-model="form.width" type="number" autocomplete="off" placeholder="请输入" />
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="车位高" prop="height">
							<el-input v-model="form.height" type="number" autocomplete="off" placeholder="请输入" />
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="submitForms">确 定</el-button>
				<el-button @click="getout">取 消</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import tableCommon from "../../../mixins/table-common";
	import {
		getCarportTypeList,
		addCarportType,
		editCarportType,
	} from "../../api/carportType";


	export default {
		mixins: [tableCommon],
		data() {
			return {
				// 请求地址api
				api: {
					list: getCarportTypeList,
					add: addCarportType,
					edit: editCarportType,
				},
				// 规则验证
				rules: {
					carport_type: [{
						required: true,
						message: "请输入车位类型",
						trigger: "blur"
					}],
					color: [{
						required: true,
						message: "请选择类型颜色",
						trigger: "change"
					}],
					product_name: [{
						required: true,
						message: "请输入产品名",
						trigger: "blur"
					}],
					width: [{
						required: true,
						message: "请输入车位宽",
						trigger: "blur"
					}],
					height: [{
						required: true,
						message: "请输入车位高",
						trigger: "blur"
					}],
				},
				// 传参
				form: {},
				// 弹窗标题
				title: "新增",
				addOrEditOpen: false,
				// 查询参数
				searchForm: {
					page: 1,
					pageSize: 25,
					carport_type: '',
				},
				tableData: [],
			};
		},
		mounted() {

		},
		methods: {
			clearSearchInput() {
				this.searchForm.carport_type = '';
				this.searchChange();
			},
			// 重置
			reset() {
				this.form = {};
			},
			// 新增弹窗
			handleNewAdd() {
				this.title = "新增";
				this.reset();
				this.handleAdd();
				this.$nextTick(() => {
					this.$refs.form.clearValidate();
				});
			},
			// 修改弹窗
			handleClick(row) {
				this.title = "修改";
				this.form = JSON.parse(JSON.stringify(row));
				this.handleEdit();
			},
			// 点击确定
			submitForms() {
				this.form.width = parseInt(this.form.width);
				this.form.height = parseInt(this.form.height);
				try {
					// 提交表单
					this.submitForm(this.form);
				} catch (error) {
					// 处理提交失败的情况
					console.error("提交失败:", error);
					// 执行适当的操作，例如显示错误提示信息或进行其他处理
				}
			},
			// 关闭弹窗
			getout() {
				this.addOrEditOpen = false;
				this.$refs.form.clearValidate();
			},
		},
	};
</script>
<style scoped>
	/deep/.dialogHeight2 .el-dialog__body {
		overflow-y: auto;
	}

	/deep/.dialogHeight .el-dialog__body {
		height: 100%;
		overflow: hidden;
	}

	/deep/.dialogHeightX .el-dialog__body {
		height: 100%;
		overflow: hidden;
	}

	/deep/.el-table,
	.el-table th,
	.el-table td {
		border-radius: 10px;
		-webkit-font-smoothing: antialiased;
		text-rendering: optimizeLegibility;
		font-size: 16px;
		font-family: Times, "Times New Roman";
		/* font-weight: 600; */
	}

	.topNav {
		display: flex;
		align-items: center;
		justify-content: space-between;
		background: #fff;
		padding: 20px 20px;
		border-radius: 10px;
	}

	.navFormWrapper {
		display: flex;
		align-items: center;
	}

	.uploadSty .el-upload--picture-card {
		width: 110px;
		height: 110px;
		line-height: 110px;
	}

	/deep/.disUploadSty .el-upload--picture-card {
		display: none;
		/* 上传按钮隐藏 */
	}

	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409eff;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 150px;
		height: 150px;
		line-height: 150px;
		text-align: center;
	}

	.avatar {
		width: 150px;
		height: 150px;
		display: block;
	}

	.avatar-wrapper {
		position: relative;
	}

	.el-icon-close {
		position: absolute;
		top: 0;
		right: 6vh;
		cursor: pointer;
	}

	.el-icon-close:hover {
		color: #409eff;
	}

	/deep/ .el-dialog__body {
		height: 60vh;
	}
</style>


// WEBPACK FOOTER //
// src/views/carportType/index.vue